/* eslint-disable react/jsx-filename-extension */
import { formatMoney } from '@transferwise/formatting';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import componentStyles from './ReceiveAmount.module.less';

const ReceiveAmount = ({
  styles,
  amount,
  currency,
  differenceToCheapest,
  optionalInlineElement,
}) => {
  const { locale } = useIntl();
  const derivedStyles = { ...componentStyles, ...styles };
  return (
    <>
      <span className={derivedStyles.receiveCell} data-testid="receive-amount">
        <span>
          <span className={derivedStyles.receiveText}>
            {formatMoney(amount, currency, locale, { alwaysShowDecimals: true })}
          </span>
          {optionalInlineElement}
        </span>

        {parseFloat(differenceToCheapest) !== 0 && (
          <span
            className={
              parseFloat(differenceToCheapest) < 0
                ? derivedStyles.negativeDelta
                : derivedStyles.positiveDelta
            }
          >
            {formatMoney(differenceToCheapest, currency, locale, { alwaysShowDecimals: true })}
          </span>
        )}
      </span>
    </>
  );
};

ReceiveAmount.propTypes = {
  styles: PropTypes.shape({
    receiveText: PropTypes.string,
    negativeDelta: PropTypes.string,
    positiveDelta: PropTypes.string,
  }),
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  differenceToCheapest: PropTypes.number.isRequired,
  optionalInlineElement: PropTypes.element,
};

ReceiveAmount.defaultProps = {
  styles: {},
  optionalInlineElement: null,
};

export default ReceiveAmount;
